import { defineMessages } from 'react-intl'

const scope = `procurify.discover-more.view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Discover more',
  },
  framingLine: {
    id: `${scope}.framingLine`,
    defaultMessage:
      "See what's new or add new capabilities to your Procurify plan.",
  },
  whatsNewTabLabel: {
    id: `${scope}.whatsNewTabLabel`,
    defaultMessage: `What's new`,
  },
  vendorPortalTabLabel: {
    id: `${scope}.vendorPortalTabLabel`,
    defaultMessage: 'Vendor portal',
  },
  earlyAccessLabel: {
    id: `${scope}.earlyAccessLabel`,
    defaultMessage: 'Early access',
  },
  guidedIntakeTabLabel: {
    id: `${scope}.guidedIntakeTabLabel`,
    defaultMessage: 'Guided Intake',
  },
  apTabLabel: {
    id: `${scope}.apTabLabel`,
    defaultMessage: 'Accounts Payable',
  },
  contractsTabLabel: {
    id: `${scope}.contractsTabLabel`,
    defaultMessage: 'Contracts',
  },
  customFieldsTabLabel: {
    id: `${scope}.customFieldsTabLabel`,
    defaultMessage: 'Custom fields',
  },
  requestDemoButtonText: {
    id: `${scope}.requestDemoButtonText`,
    defaultMessage: 'Request a meeting',
  },
  demoDisclaimer: {
    id: `${scope}.demoDisclaimer`,
    defaultMessage:
      'By clicking this button, you agree to be contacted by a Procurify representative.',
  },
  vendorPortalHeader: {
    id: `${scope}.vendorPortalHeader`,
    defaultMessage: 'Let vendors keep their own records current',
  },
  vendorPortalDescription: {
    id: `${scope}.vendorPortalDescription`,
    defaultMessage:
      'Vendors update their contact, tax and banking details in a portal of their own, so your vendor list stays accurate without the email chase.',
  },
  vendorPortalProofPointInviteProgress: {
    id: `${scope}.vendorPortalProofPointInviteProgress`,
    defaultMessage:
      'Invite a vendor once and follow their progress through details, tax and payment setup.',
  },
  vendorPortalProofPointMessaging: {
    id: `${scope}.vendorPortalProofPointMessaging`,
    defaultMessage:
      'Exchange messages about POs and bills in context, without either side leaving Procurify.',
  },
  vendorPortalProofPointDashboard: {
    id: `${scope}.vendorPortalProofPointDashboard`,
    defaultMessage:
      'Vendor dashboard for visibility on their POs and invoices.',
  },
  vendorPortalEarlyAccessButtonText: {
    id: `${scope}.vendorPortalEarlyAccessButtonText`,
    defaultMessage: 'Get early access',
  },
  vendorPortalHeroImageAlt: {
    id: `${scope}.vendorPortalHeroImageAlt`,
    defaultMessage:
      'Vendor portal where a vendor updates their contact, tax and banking details',
  },
  guidedIntakeHeader: {
    id: `${scope}.guidedIntakeHeader`,
    defaultMessage: 'Build requests without the guesswork',
  },
  guidedIntakeDescription: {
    id: `${scope}.guidedIntakeDescription`,
    defaultMessage:
      'Guided Intake is a conversational AI agent that builds a structured, policy-compliant purchase request from what you describe using your policies, catalogs, and order history.',
  },
  guidedIntakeProofPointPolicyMatch: {
    id: `${scope}.guidedIntakeProofPointPolicyMatch`,
    defaultMessage: 'Matches items to your policy and budget',
  },
  guidedIntakeProofPointAutomaticCoding: {
    id: `${scope}.guidedIntakeProofPointAutomaticCoding`,
    defaultMessage: 'Cuts manual work with auto-coding',
  },
  guidedIntakeProofPointFlagsIssues: {
    id: `${scope}.guidedIntakeProofPointFlagsIssues`,
    defaultMessage: 'Flags issues before they cause delays',
  },
  guidedIntakeHeroImageAlt: {
    id: `${scope}.guidedIntakeHeroImageAlt`,
    defaultMessage:
      'Guided Intake building a structured purchase request from a plain-language message',
  },
  apHeader: {
    id: `${scope}.apHeader`,
    defaultMessage: 'Turn approved POs into paid bills',
  },
  apDescription: {
    id: `${scope}.apDescription`,
    defaultMessage:
      'Agentic AI agents match invoices to POs, extract bill details, and help you pay vendors from one connected workflow.',
  },
  apProofPointInvoiceMatching: {
    id: `${scope}.apProofPointInvoiceMatching`,
    defaultMessage:
      'Automate 2- and 3-way invoice matching to eliminate manual review',
  },
  apProofPointGlobalPayments: {
    id: `${scope}.apProofPointGlobalPayments`,
    defaultMessage:
      'Pay global vendors in 190+ countries with $0 FX transfer fees',
  },
  apProofPointErpSync: {
    id: `${scope}.apProofPointErpSync`,
    defaultMessage:
      'Keep financial records accurate with real-time ERP payment sync',
  },
  apHeroImageAlt: {
    id: `${scope}.apHeroImageAlt`,
    defaultMessage:
      'An invoice matched against a purchase order and routed for payment',
  },
  contractsHeader: {
    id: `${scope}.contractsHeader`,
    defaultMessage: 'Take control of contract spend',
  },
  contractsDescription: {
    id: `${scope}.contractsDescription`,
    defaultMessage:
      "Contracts pulls every agreement's terms and dates into one searchable record, so nothing auto-renews or expires unnoticed.",
  },
  contractsProofPointCentralizedView: {
    id: `${scope}.contractsProofPointCentralizedView`,
    defaultMessage:
      'Centralize all your vendor contracts in one searchable view',
  },
  contractsProofPointRenewalAlerts: {
    id: `${scope}.contractsProofPointRenewalAlerts`,
    defaultMessage:
      'Prevent costly auto-renewals with automated expiration alerts',
  },
  contractsProofPointLinkedPurchaseOrders: {
    id: `${scope}.contractsProofPointLinkedPurchaseOrders`,
    defaultMessage:
      'Control spend by linking purchase orders directly to contract terms',
  },
  contractsHeroImageAlt: {
    id: `${scope}.contractsHeroImageAlt`,
    defaultMessage:
      'A contract repository listing vendor agreements with renewal dates and expiration countdowns',
  },
  customFieldsHeader: {
    id: `${scope}.customFieldsHeader`,
    defaultMessage: 'Add custom fields to Procurify',
  },
  customFieldsDescription: {
    id: `${scope}.customFieldsDescription`,
    defaultMessage:
      'Add additional custom fields to your plan, so growing teams can capture more detail in existing workflows without changing how existing fields work.',
  },
  customFieldsHeroImageAlt: {
    id: `${scope}.customFieldsHeroImageAlt`,
    defaultMessage:
      'The custom fields setup page listing header fields and line item fields',
  },
  aiLabel: {
    id: `${scope}.aiLabel`,
    defaultMessage: 'AI',
  },
})
